module.exports = __webpack_public_path__ + "static/img/banner.52f1249.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.png
// module id = P07D
// module chunks = 0